import { Box } from '@mui/material';
import TopSideBarIcon from '../../../../assets/topbar-icon/TALL_ROBI_LBS.png';

const LeftTopHeader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: { xs: '8px', sm: '12px' }, // Adjust padding as needed
        maxWidth: '200px', // Optional, limit max width of the box
      }}
    >
      <Box
        component='img'
        src={TopSideBarIcon}
        alt='logo'
        sx={{
          width: { xs: '80px', sm: '100px', md: '120px' }, // Responsive width
          height: 'auto', // Keeps the logo's aspect ratio
          maxHeight: '72px', // Maximum height for larger screens
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};

export default LeftTopHeader;
